//authServices.js
import apiClient from '../api/apiClient';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const authServices = {

  login: async (mobile, password, recaptcha, app_version, platform) => {
    try {
      const response = await apiClient.post(`/api/auth/login/`, {
        mobile: mobile,
        password: password,
        app_version: app_version,
        platform: platform,
      });

      if (response.data.success) {
        // Store all user information in localStorage
        const userData = response.data.data.user;
        localStorage.setItem('authToken', response.data.data.tokens.access);
        localStorage.setItem('refreshToken', response.data.data.tokens.refresh);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('UserRole', userData.role);
        localStorage.setItem('UserMobile', userData.mobile);
        localStorage.setItem('UserId', userData.id);
        localStorage.setItem('UserName', userData.name);
        localStorage.setItem('ShopName', userData.shop_name);
        localStorage.setItem('CustomerID', userData.customer_id);
        
        return { 
          success: {
            user: userData,
            tokens: response.data.data.tokens
          } 
        };
      } else {
        return { errorMsg: response.data.message || "Login failed" };
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "An unknown error occurred";
      console.error("Login error: ", errorMessage);
      return { errorMsg: errorMessage };
    }
  },

  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('UserRole');
    localStorage.removeItem('UserName');
    localStorage.removeItem('UserMobile');
    localStorage.removeItem('UserId');
    localStorage.removeItem('ShopName');
    localStorage.removeItem('CustomerID');
    localStorage.removeItem('dark-mode');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');  // Returns true if token exists
  },

  getToken: () => {
    return localStorage.getItem('authToken');
  },

  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await apiClient.post('/api/auth/refresh-token/', {
        refresh_token: refreshToken
      });

      if (response.data.success) {
        // Update tokens in localStorage
        localStorage.setItem('authToken', response.data.data.access);
        localStorage.setItem('refreshToken', response.data.data.refresh);
        
        // Update user data if provided
        if (response.data.data.user) {
          localStorage.setItem('UserRole', response.data.data.user.role);
          localStorage.setItem('UserMobile', response.data.data.user.mobile);
          localStorage.setItem('UserId', response.data.data.user.id);
          localStorage.setItem('user', JSON.stringify(response.data.data.user));
        }
        
        return { success: true, access: response.data.data.access };
      } else {
        throw new Error(response.data.message || 'Token refresh failed');
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      return { success: false, error: error.message };
    }
  },

  changePassword: async (oldPassword, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post('/api/auth/change-password/', {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword
      });

      return response.data;
    } catch (error) {
      console.error('Change password error:', error);

      if (error.response?.data) {
        return error.response.data;
      }

      return {
        success: false,
        message: 'Failed to change password. Please try again.'
      };
    }
  },

  forgotPassword: async (mobile) => {
    try {
      const response = await apiClient.post('/api/auth/forgot-password/', {
        mobile: mobile
      });

      return response.data;
    } catch (error) {
      console.error('Forgot password error:', error);

      // Extract error message from various possible fields
      let errorMessage = 'Failed to send OTP. Please try again.';

      if (error.response?.data) {
        const data = error.response.data;

        // Try to extract message from common error response formats
        errorMessage = data.message ||
                      data.error ||
                      data.detail ||
                      data.mobile?.[0] || // Field-specific errors (e.g., ["Invalid phone number"])
                      data.non_field_errors?.[0] ||
                      errorMessage;

        return {
          success: false,
          message: errorMessage
        };
      }

      return {
        success: false,
        message: error.message || errorMessage
      };
    }
  },

  resetPassword: async (mobile, otp, newPassword, confirmPassword) => {
    try {
      const response = await apiClient.post('/api/auth/reset-password/', {
        mobile: mobile,
        otp: otp,
        new_password: newPassword,
        confirm_password: confirmPassword
      });

      return response.data;
    } catch (error) {
      console.error('Reset password error:', error);

      // Extract error message from various possible fields
      let errorMessage = 'Failed to reset password. Please try again.';

      if (error.response?.data) {
        const data = error.response.data;

        // Try to extract message from common error response formats
        errorMessage = data.message ||
                      data.error ||
                      data.detail ||
                      data.otp?.[0] || // OTP-specific errors
                      data.mobile?.[0] ||
                      data.new_password?.[0] ||
                      data.confirm_password?.[0] ||
                      data.non_field_errors?.[0] ||
                      errorMessage;

        return {
          success: false,
          message: errorMessage
        };
      }

      return {
        success: false,
        message: error.message || errorMessage
      };
    }
  },
};

export default authServices;